module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Hero Shot_RGB_lr.eb2da7e5.jpg";